var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { getData, getListWithParams, postData, putData, removeData } from "./CommonService";
/**
 * Fetches a list of database DTOs (Data Transfer Objects) from a specified endpoint.
 * This function is generic and can be used for various database listings.
 *
 * @template T - The type of the DTOs in the list.
 * @param {string} endpoint - The API endpoint URL for fetching the list.
 * @param {DBQueryParams} body - Query parameters for pagination, filtering, etc.
 * @returns {Promise<{ databaseDTOList: T[]; count: number } | null>} A promise that resolves to an object
 * containing the list of DTOs and their total count on success, or `null` if the request fails or is not successful.
 * @author niyas.shajahan
 * @since 2025-06-19
 */
export var fetchDbList = function (endpoint, body) { return __awaiter(void 0, void 0, void 0, function () {
    var response, databaseDTO, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                console.log("DBQueryParams", body);
                return [4 /*yield*/, postData(endpoint, body)];
            case 1:
                response = _a.sent();
                if (response.responseStatus === "SUCCESS") {
                    databaseDTO = response.responseBody;
                    // If responseBody is a string, parse it as JSON
                    if (typeof databaseDTO === "string") {
                        databaseDTO = JSON.parse(databaseDTO);
                    }
                    return [2 /*return*/, databaseDTO];
                }
                else {
                    console.warn("API response not successful:", response.responseStatus);
                    return [2 /*return*/, null];
                }
                return [3 /*break*/, 3];
            case 2:
                error_1 = _a.sent();
                console.error("API request failed:", error_1);
                return [2 /*return*/, null];
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * Deletes data records by their IDs from a specified endpoint.
 *
 * @param {string[]} ids - An array of IDs of the records to be deleted.
 * @param {string} endpoint - The API endpoint URL for the delete operation (e.g., "/cache04/delete").
 * @param {string} paramname - This define what name of the parameter mentioned in delete endpoint
 * @returns {Promise<boolean>} A promise that resolves to `true` if the deletion was successful (HTTP status 200),
 * or `false` otherwise.
 * @author rajeev.k
 * @since 2025-09-11
 */
export var deleteData = function (ids, endpoint, paramname) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_2;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                return [4 /*yield*/, removeData(endpoint, {
                        params: (_a = {}, _a[paramname] = ids, _a),
                    })];
            case 1:
                response = _b.sent();
                return [2 /*return*/, response.responseStatus === "SUCCESS"]; // Return true if HTTP status is 200 (OK)
            case 2:
                error_2 = _b.sent();
                console.error("Error deleting data from ".concat(endpoint, ":"), error_2);
                return [2 /*return*/, false];
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * Uploads an XML file and retrieves the parsed DTO from the backend.
 *
 * This function sends a multipart/form-data request to upload the XML file
 * along with optional metadata (like message type or user ID), and expects
 * the server to return a parsed object representing the file content.
 *
 * @template T - The expected DTO type returned by the backend.
 * @param file - The XML file to upload.
 * @param url - The API endpoint to which the file will be uploaded.
 * @param metadata - Optional key-value pairs to include in the upload form data (e.g., messagetype, userid).
 * @returns A promise resolving to the parsed DTO or null if the request fails or the response is unsuccessful.
 *
 * @author Renjith Kartha
 * @since 2025-07-09
 */
export var uploadAndParseToDto = function (file_1) {
    var args_1 = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args_1[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([file_1], args_1, true), void 0, function (file, format, callbacks, metadata, url) {
        var endpoint, formData, key, response, error_3, apiError;
        var _a;
        if (format === void 0) { format = 'xml'; }
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    endpoint = url || "/".concat(format, "/upload-parse");
                    formData = new FormData();
                    formData.append("file", file);
                    if (metadata) {
                        for (key in metadata) {
                            formData.append(key, metadata[key]);
                        }
                    }
                    return [4 /*yield*/, postData(endpoint, formData, {
                            headers: {
                                "Content-Type": "multipart/form-data",
                            },
                        })];
                case 1:
                    response = _b.sent();
                    callbacks.onSuccess(response);
                    return [3 /*break*/, 3];
                case 2:
                    error_3 = _b.sent();
                    console.log("Catched exception " + error_3);
                    apiError = (_a = error_3 === null || error_3 === void 0 ? void 0 : error_3.response) === null || _a === void 0 ? void 0 : _a.data;
                    callbacks.onError(apiError);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
};
/**
 * Saves a message to a specified backend URL.
 *
 * @template T - The type of the message being saved.
 * @param {T} message - The message object to be saved.
 * @param {string} url - The API endpoint URL to which the message will be sent (e.g., "/cache04/save").
 * on success, or `null` if the saving operation fails.
 * @author rajeev.k
 * @since 2025-08-25
 */
export var saveMessage = function (message, url, callbacks) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_4, apiError;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                return [4 /*yield*/, postData(url, message)];
            case 1:
                response = _b.sent();
                console.log(" saveMessage " + response);
                callbacks.onSuccess(response);
                console.log("Not Catched exception ");
                return [3 /*break*/, 3];
            case 2:
                error_4 = _b.sent();
                console.log("Catched exception " + error_4);
                apiError = (_a = error_4 === null || error_4 === void 0 ? void 0 : error_4.response) === null || _a === void 0 ? void 0 : _a.data;
                callbacks.onError(apiError);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * Fetches a single message or record by user ID and message ID from a specified URL.
 *
 * @template T - The type of the message/record to fetch.
 * @param {object} params - Parameters for the fetch request.
 * @param {string | undefined} params.userId - The ID of the user associated with the message.
 * @param {number} [params.messageId] - The optional ID of the specific message to fetch.
 * @param {string} url - The API endpoint URL for fetching the message (e.g., "/cache04/get").
 * @returns {Promise<T | null>} A promise that resolves to the fetched message object on success,
 * or `null` if the request fails or the response is not successful.
 * @author rajeev.k
 * @since 2025-09-09
 */
export var fetchMessage = function (params, url) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, getListWithParams(url, params)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response === null || response === void 0 ? void 0 : response.responseBody];
            case 2:
                error_5 = _a.sent();
                console.error("getting user details failed", error_5);
                return [2 /*return*/, null];
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * to update user and mandant details
 * @param userDetails
 * @returns
 */
/**
 * to update user and mandant details
 * @param userDetails
 * @returns
 */
export var updateUser = function (message, url, callbacks) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_6;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                return [4 /*yield*/, putData(url, message)];
            case 1:
                response = _b.sent();
                callbacks.onSuccess(response);
                return [3 /*break*/, 3];
            case 2:
                error_6 = _b.sent();
                callbacks.onError((_a = error_6 === null || error_6 === void 0 ? void 0 : error_6.response) === null || _a === void 0 ? void 0 : _a.data);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var getEoriList = function (masterDataUrl, callbacks) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_7;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 2, , 3]);
                return [4 /*yield*/, getData(masterDataUrl)];
            case 1:
                response = _c.sent();
                callbacks.onSuccess(response);
                return [3 /*break*/, 3];
            case 2:
                error_7 = _c.sent();
                console.error("API request failed during logout:", ((_a = error_7 === null || error_7 === void 0 ? void 0 : error_7.response) === null || _a === void 0 ? void 0 : _a.data) || (error_7 === null || error_7 === void 0 ? void 0 : error_7.message));
                callbacks.onError((_b = error_7 === null || error_7 === void 0 ? void 0 : error_7.response) === null || _b === void 0 ? void 0 : _b.data);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); };
export function handleMetaData(metaDataDTO) {
    var _a;
    var metaData = __assign({}, metaDataDTO);
    // Reset messageId if present
    if (metaData === null || metaData === void 0 ? void 0 : metaData.messageId) {
        metaData.messageId = "";
    }
    // Handle EORI Number
    var eoriNumber = (_a = metaData === null || metaData === void 0 ? void 0 : metaData.messageSender) === null || _a === void 0 ? void 0 : _a.eoriNumber;
    if (eoriNumber) {
        var _b = eoriNumber.split(" - "), identificationNumber = _b[0], subsidiaryNumber = _b[1];
        metaData.messageSender.identificationNumber =
            (identificationNumber === null || identificationNumber === void 0 ? void 0 : identificationNumber.trim()) || "";
        metaData.messageSender.subsidiaryNumber = (subsidiaryNumber === null || subsidiaryNumber === void 0 ? void 0 : subsidiaryNumber.trim()) || "";
    }
    return metaData;
}
